<template>
    <div>

        <div class="d-block d-print-none">
            <div class="input-group input-group-sm mb-2 mt-3">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <input type="checkbox" aria-label="Checkbox for following text input" v-model="com_valores">
                    </div>
                </div>
                <label class="form-control">Apenas fornecedores com valores</label>
            </div>
        </div>

        <div class="table-responsive-md cabecalho-fixo-modal" v-if="tabela">
            <table class="table" id="tabela-mapa-cotacao">
                <thead>
                    <tr>
                        <th>Descrição</th>
                        <template v-for="(fornec, ifx) in tabela.fornecedores">
                            <th :key="ifx"
                                v-if="!com_valores || totalizar_precos(fornec, false) > 0"
                                class="text-right small">
                                {{ fornec.fornecedor.search }}
                                <div class="card-link">
                                    <a href="#" @click.prevent="mostrar_detalhe_condicoes(fornec)">
                                        {{ fornec.resumo_condicoes }}
                                    </a>
                                    <i class="fas fa-dollar-sign fa-fw ml-1"></i>
                                </div>
                                <div class="text-muted" v-if="fornec.st_tipo_prazo_entrega">
                                    {{ fornec.st_tipo_prazo_entrega }}
                                    <i class="fas fa-truck-loading fa-fw ml-1"></i>
                                </div>
                                <div class="text-muted" v-if="fornec.fornecedor.dc_valor_minimo">
                                    Mínimo: {{ $util.formatMoeda(fornec.fornecedor.dc_valor_minimo) }}
                                    <i class="fa fa-info-circle fa-fw ml-1" aria-hidden="true"></i>
                                </div>
                                <div class="text-muted" v-if="fornec.st_tipo_frete == 'FOB' && fornec.dc_valor_frete">
                                    Frete: {{ $util.formatMoeda(fornec.dc_valor_frete) }}
                                    <i class="fa-solid fa-truck fa-fw ml-1"></i>
                                </div>
                            </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(aqitem, iax) in tabela.items" :key="iax">
                        <td>
                            {{ aqitem.search }}
                            <span class="badge badge-secondary">#{{ aqitem.id_estoque_item }}</span>
                            <span class="text-muted small ml-2">
                                {{ aqitem.st_unidade }}
                                <span v-if="aqitem.in_fator != 1" class="ml-1">({{ aqitem.in_fator }})</span>
                            </span>
                            <div>
                                <span class="text-muted small mr-3" v-if="aqitem.estoque_item && aqitem.estoque_item.ultimas_entradas && aqitem.estoque_item.ultimas_entradas.length" title="Preço da Última Compra">
                                    <i class="fa fa-history" aria-hidden="true"></i>
                                    {{ $util.formatMoeda(aqitem.estoque_item.ultimas_entradas[0].dc_valor) }}
                                </span>
                                <span class="text-muted small mr-3" v-if="aqitem.estoque_item && aqitem.estoque_item.saldo && aqitem.estoque_item.saldo.pm" title="Preço Médio">
                                    <i class="fas fa-dollar-sign"></i>
                                    {{ $util.formatMoeda(aqitem.estoque_item.saldo.pm) }}
                                </span>
                                <span class="text-muted small mr-3" v-if="aqitem.estoque_item && aqitem.estoque_item.saldo" title="Saldo">
                                    <i class="fas fa-boxes"></i>
                                    {{ aqitem.estoque_item.saldo.qtd }}
                                </span>
                                <span class="text-muted small mr-3" v-if="aqitem.estoque_item && aqitem.estoque_item.item_parm && aqitem.estoque_item.item_parm.in_cmm > 0" title="Consumo Médio Mensal">
                                    <i class="fas fa-cookie-bite"></i>
                                     {{ aqitem.estoque_item.item_parm.in_cmm }}
                                </span>
                            </div>
                        </td>
                        <template v-for="(fornec, ifx) in tabela.fornecedores">
                            <td :key="ifx"
                                v-if="!com_valores || totalizar_precos(fornec, false) > 0"
                                class="text-right" 
                                :class="!obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'dc_preco', 'M')
                                    ? 'table-secondary' 
                                    : ( obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'fl_selecionado') ? 'table-primary' : '' )">

                                <template v-if="viewonly">
                                    <span>
                                        {{ obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'dc_preco', 'M') }}
                                    </span>
                                </template>
                                <template v-else>
                                    <a href="#" @click.prevent="selecionar_preco(aqitem.id_aquisicao_item, fornec.precos)">
                                        {{ obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'dc_preco', 'M') }}
                                    </a>
                                </template>

                                <div class="small text-muted" v-if="obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'dc_preco', 'M')">
                                    {{ obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'dc_quantidade', 'Q') }}
                                    <i class="fas fa-equals mx-2"></i>
                                    {{ obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'total', 'M') }}
                                </div>

                                <div v-if="aqitem" class="small text-muted">
                                    {{ obter_preco(aqitem.id_aquisicao_item, fornec.precos, 'st_observacao') }}
                                </div>
                            </td>
                        </template>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>Total:</td>
                        <template v-for="(fornec, ifx) in tabela.fornecedores">
                            <td :key="ifx" class="text-right" v-if="!com_valores || totalizar_precos(fornec, false) > 0">
                                <div v-if="totalizar_precos(fornec, true) > 0">
                                    {{ $util.formatMoeda(totalizar_precos(fornec, true)) }}
                                    <span v-if="fornec.fornecedor.dc_valor_minimo && totalizar_precos(fornec, true) < fornec.fornecedor.dc_valor_minimo">
                                        <i class="fa fa-exclamation-triangle text-danger ml-2" aria-hidden="true" title="Valor mínimo não alcançado."></i>
                                    </span>
                                </div>
                                <div class="small text-muted">
                                    {{ $util.formatMoeda(totalizar_precos(fornec, false)) }}
                                </div>
                            </td>
                        </template>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- Modal de Detalhe de Condições -->
        <div class="modal fade" id="condicoesPrecoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="condicoes">
                    <div class="modal-header">
                        <h5 class="modal-title">Detalhe Condições</h5>
                        <button type="button" class="close" @click="fechar('condicoesPrecoModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <span v-html="condicoes.detalhe_condicoes"></span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('condicoesPrecoModal')">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';

export default {
    data() { 
        return { 
            condicoes: null, 
            com_valores: false, 
        }
    },

    props: ['tabela', 'viewonly'],

    methods: { 
        fechar(modal) { 
            $('#' + modal).modal('hide');
        },

        totalizar_precos (fornec, selec = false) { 
            return fornec.precos.filter(preco => !selec || preco.fl_selecionado)
                .reduce((total, carry) => total + ( parseFloat(carry.dc_preco) * parseFloat(carry.dc_quantidade) ), 0);
        },

        mostrar_detalhe_condicoes (info) {
            this.condicoes = info;

            $('#condicoesPrecoModal').modal('show');
        },

        selecionar_preco(id, precos) { 
            let preco = precos.find(item => item.id_aquisicao_item == id);
            
            if ( preco ) { 
                preco.fl_selecionado = !preco.fl_selecionado;
            }
        },

        obter_preco(id, precos, campo, format = null) { 
            let preco = precos.find(item => item.id_aquisicao_item == id);
            
            if ( preco ) { 
                let valor;

                switch (campo) {
                    case 'total':
                        valor = _.get(preco, 'dc_preco') * _.get(preco, 'dc_quantidade');
                        break;
                
                    default:
                        valor = _.get(preco, campo);
                        break;
                }

                switch (format) {
                    case 'M':
                        valor = valor > 0 ? this.$util.formatMoeda(valor, 6, 2) : null;       
                        break;

                    case 'Q':
                        valor = valor > 0 ? this.$util.formatNumber(valor, 0) : null;       
                        break;
                
                    default:
                        break;
                }

                return valor;
            }
                
        },
    }
}
</script>